import { Modal } from 'antd';
import { Trans } from 'react-i18next';

import { JobPostingActionModal } from './VacancyActions';

const CloneVacancyModal: React.FC<JobPostingActionModal> = ({ jobPosting, ...props }) => {
  return (
    <Modal {...props}>
      <span>
        <Trans>
          Uma nova vaga será criada com todas as configurações da vaga atual.{' '}
          <strong>Atenção:</strong> se houver um roteiro de entrevista iniciado, ele{' '}
          <strong>não será copiado</strong>. Tem certeza que deseja clonar a vaga{' '}
        </Trans>
        <strong>{jobPosting.name}</strong>?
      </span>
    </Modal>
  );
};

export default CloneVacancyModal;
